import React, { Component, Fragment } from 'react';
import { NavItem, NavLink, UncontrolledTooltip } from 'reactstrap';
import { NavLink as NavLinkRRD } from 'react-router-dom';
import { isNavigationPathActive } from '../../../helpers/activeNavigation';

class Links extends Component {
  activeRoute = () => {
    return isNavigationPathActive(
      this.props.location.pathname,
      this.props.path,
      this.props.activePaths,
      this.props.exact
    );
  };

  render() {
    const active = this.activeRoute();
    const hasLocalizedDestinationName = React.isValidElement(this.props.name);
    const shouldRenderTooltip = hasLocalizedDestinationName && !this.props.sidenavOpen;
    const linkId = hasLocalizedDestinationName ? `sidebar-link-${this.props.index}` : this.props.index;
    const labelId = `sidebar-link-label-${linkId}`;

    return (
      <NavItem className={active ? 'active' : ''}>
        <NavLink
          to={this.props.path}
          activeClassName=""
          aria-current={active ? 'page' : undefined}
          aria-labelledby={hasLocalizedDestinationName ? labelId : undefined}
          isActive={() => active}
          tag={NavLinkRRD}
          id={ linkId }
        >
          {
            this.props.icon !== undefined && this.props.icon.length ? (
              <Fragment>
                <i className={ this.props.icon } />
                <span className="nav-link-text">{ this.props.name }</span>
              </Fragment>
            ) : this.props.miniName !== undefined ? (
              <Fragment>
                <span className="sidenav-mini-icon"> { this.props.miniName } </span>
                <span className="sidenav-normal"> { this.props.name } </span>
              </Fragment>
            ) : (
              this.props.name
            )
          }
          {hasLocalizedDestinationName && (
            <span className="sr-only" id={labelId}>{ this.props.name }</span>
          )}
        </NavLink>
        {shouldRenderTooltip && (
          <UncontrolledTooltip delay={0} target={linkId} trigger="hover focus">
            { this.props.name }
          </UncontrolledTooltip>
        )}
      </NavItem>
    )
  }
}

Links.defaultProps = {
  name: '',
  path: '',
  icon: '',
  miniName: '',
  index: 0,
  activePaths: [],
  exact: false,
  sidenavOpen: true,
  location: {
    pathname: ''
  }
};

export { Links };
